import { useEffect, useState } from 'react';
import OT from '@opentok/client';
import Logger from '@medflex/utils/Logger';

const useTokboxProxy = ({ url = null }) => {
  const [isProxyInitialized, setProxyInitialized] = useState(false);

  useEffect(() => {
    if (!isProxyInitialized && url !== null) {
      Logger.log(`Setting OT proxyUrl ${url}`);
      OT.setProxyUrl(url);
      setProxyInitialized(true);
    }
  }, [url]);

  return isProxyInitialized;
};

export default useTokboxProxy;
